import {Injectable} from '@angular/core';
import {LookupService} from './lookup.service';
import {DataFrameLookup} from '../models/data-frame.model';
import {Extent} from '../models/extent.model';

@Injectable({
    providedIn: 'root'
})
export class DataFrameService {
    title = 'DataFrameService';

    constructor(private lookupService: LookupService) {}

    getDataFrame(coordSystem: number, paperSize: number, scale: number, qtdPerPage: number, extent: Extent) {
        console.debug(`${this.title} - getDataFrame`);

        const dataFrameLookup = this.lookupService
            .getLookups('dataFrame')
            .find((v: DataFrameLookup) => v.coordSystem === coordSystem && v.paperSize === paperSize && v.qtdPerPage === qtdPerPage);
        const scaledX = scale * dataFrameLookup.x;
        const scaledY = scale * dataFrameLookup.y;

        const centerX = extent.xmin + (extent.xmax - extent.xmin) / 2;
        const centerY = extent.ymin + (extent.ymax - extent.ymin) / 2;

        const dataFrame = {
            xmin: centerX - scaledX,
            xmax: centerX + scaledX,
            ymin: centerY - scaledY,
            ymax: centerY + scaledY
        } as Extent;

        console.debug(`${this.title} - getDataFrame - dataFrame:`, dataFrame);

        return dataFrame;
    }
}
